<template>
    <div>
        <div>
            <div class="flex w-full mt-3">
                <div class="grid h-60 bg-base-300 flex-grow rounded-box place-items-center">
                    <p>
                        {{ allowed_message }}
                    </p>
                    <label
                        for="notification"
                        class="btn btn-primary"
                        @click="model = 'allowed_users'"
                    >
                        Küldés
                    </label>
                </div>
                <div class="divider divider-horizontal"></div>
                <div class="grid h-60 bg-base-300 flex-grow rounded-box place-items-center">
                    <p>
                        {{ reservation_message }}
                    </p>
                    <label
                        for="notification"
                        class="btn btn-primary mt-3"
                        @click="model = 'reservations'"
                    >
                        Küldés
                    </label>
                </div>
            </div>
        </div>

        <!-- Put this part before </body> tag -->
        <input type="checkbox" id="notification" class="modal-toggle" />
        <label class="modal" for="notification">
            <label class="modal-box reactive" for="">
                <label
                    for="notification"
                    class="btn btn-sm btn-error btn-square cursor-pointer fill-base-content text-base-100 absolute right-2 top-2"
                >
                    <CloseIcon transparent/>
                </label>
                <h3 class="font-bold text-lg">Tömeges értesítés küldése</h3>
                <p class="py-4">
                    {{ model === 'allowed_users' ? allowed_message : reservation_message }}
                </p>
                <div class="modal-action">
                    <label
                        @click="
                            model === 'allowed_users'
                                ? sendAllowedUserNotification(period_id)
                                : sendSystemReserveNotification(period_id)
                        "
                        for="notification"
                        class="btn btn-primary"
                    >
                        Küldés
                    </label>
                </div>
            </label>
        </label>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CloseIcon from "../svg/CloseIcon";

export default {
    name: 'Reservations',
    components: { CloseIcon },
    props: {
        period_id: {
            required: true,
            type: Number,
        },
    },
    data() {
        return {
            model: '',
        };
    },
    computed: {
        ...mapGetters('Period', ['allowed_users', 'reservations']),
        allowed_message() {
            return `Értesítés küldése ${this.allowed_users.length} hallgató számára, hogy szobafoglalásra jogosultak`;
        },
        reservation_message() {
            return `Értesítés küldése ${this.reservations.length} hallgató számára, hogy előjoggal rendelkeznek`;
        },
    },
    methods: {
        ...mapActions('Period', ['sendSystemReserveNotification', 'sendAllowedUserNotification']),
    },
};
</script>

<style scoped></style>
